import React from "react";
import { useGhlTags } from "../../../state/api/services/ghl/useTags";
import Pill from "../pill/Pill";
import LoadingSpinner from "../loader/LoadingSpinner";
import Icon from "../icons/Icon";

interface Props {
  id: string;
}

export default function GhlTag(props: Props) {
  const { isLoading, tagsById } = useGhlTags();

  const tagLabel = tagsById?.[props.id]?.name;
  const label = tagLabel || props.id;

  if (!tagLabel && !isLoading) {
    return null;
  }

  return (
    <Pill>
      <div className="d-flex flex-row gap-2 align-items-center">
        <Icon loading={isLoading} icon="tag" />
        <span>{label}</span>
      </div>
    </Pill>
  )
}